<template>
    <div class="qksm qksm13">
        <h4>十三、政府采购支出决算情况说明</h4>
        <div class="nogap">
            <p>
                {{$parent.year}}年度政府采购支出总额{{isMoney(T13.总计)}}万元，其中：政府采购货物支出{{isMoney(T13.货物)}}万元、政府采购工程支出{{isMoney(T13.工程)}}万元、政府采购服务支出{{isMoney(T13.服务)}}万元。政府采购授予中小企业合同金额{{isMoney(T13.中小)}}万元，
                <span v-if="T13.总计 > 0">
                    占政府采购支出总额的{{calcRatio(T13.中小,T13.总计)}}，
                </span>
                其中：授予小微企业合同金额{{isMoney(T13.小微)}}万元
                <span v-if="T13.总计 > 0">
                    ，占政府采购支出总额的{{calcRatio(T13.小微,T13.总计)}}
                </span>。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm13",
        props: {
            T13: {
                type: Object,
                default: "",
            },
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        components: {
            reason,
        },
    };
</script>
